import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Mail, Clock, ArrowRight } from "lucide-react";
import { useSearchParams, Link } from "react-router-dom";
import { useEffect } from "react";

const Success = () => {
  const [searchParams] = useSearchParams();
  const productType = searchParams.get("product_type");
  const sessionId = searchParams.get("session_id");

  // Nettoyer le code affilié du localStorage après un achat réussi
  useEffect(() => {
    if (sessionId) {
      console.log("✅ Paiement réussi - Session:", sessionId);
      // Le webhook Stripe a déjà traité la commission affilié
      // On peut nettoyer le localStorage
      localStorage.removeItem('affiliate_code');
    }
  }, [sessionId]);

  const getProductName = () => {
    switch (productType) {
      case "3months":
        return "Accès 3 Mois";
      case "6months":
        return "Accès 6 Mois";
      case "12months":
        return "Accès 12 Mois VIP";
      case "monthly":
        return "Accès Mensuel";
      default:
        return "Accès";
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="max-w-lg w-full text-center border-2 border-primary/20">
        <CardContent className="p-8">
          <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-500" />
          </div>
          
          <h1 className="text-3xl font-bold mb-2 text-foreground">
            Paiement Confirmé ! 🎉
          </h1>
          
          <p className="text-primary font-semibold text-lg mb-4">
            {getProductName()}
          </p>
          
          <p className="text-muted-foreground mb-8">
            Merci pour votre confiance ! Votre commande a été traitée avec succès.
          </p>

          {/* Alerte email importante */}
          <div className="bg-amber-500/20 border-2 border-amber-500 rounded-xl p-4 mb-6">
            <div className="flex items-center gap-3">
              <Mail className="w-8 h-8 text-amber-500 flex-shrink-0" />
              <div>
                <p className="font-bold text-amber-600 text-lg">
                  📧 Vérifiez vos emails ET vos spams !
                </p>
                <p className="text-sm text-amber-700">
                  Votre email de confirmation peut arriver dans les spams. Pensez à vérifier !
                </p>
              </div>
            </div>
          </div>

          {/* Étapes suivantes */}
          <div className="bg-muted/50 rounded-xl p-6 mb-8 text-left space-y-4">
            <h3 className="font-semibold text-foreground flex items-center gap-2">
              <Clock className="w-5 h-5 text-primary" />
              Prochaines étapes
            </h3>
            
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-bold flex-shrink-0">
                  1
                </div>
                <div>
                  <p className="text-foreground font-medium">Vérifiez votre boîte email</p>
                  <p className="text-sm text-muted-foreground">
                    Vos identifiants de connexion seront envoyés dans les prochaines minutes
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-bold flex-shrink-0">
                  2
                </div>
                <div>
                  <p className="text-foreground font-medium">Installez l'application</p>
                  <p className="text-sm text-muted-foreground">
                    Suivez nos tutoriels pour configurer votre appareil
                  </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-bold flex-shrink-0">
                  3
                </div>
                <div>
                  <p className="text-foreground font-medium">Profitez !</p>
                  <p className="text-sm text-muted-foreground">
                    +15 000 chaînes et +100 000 films & séries vous attendent
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Link to="/tutoriels" className="block">
              <Button className="w-full btn-primary">
                Voir les tutoriels d'installation
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
            
            <Link to="/" className="block">
              <Button variant="outline" className="w-full">
                Retour à l'accueil
              </Button>
            </Link>
          </div>
          
          <div className="mt-6 pt-6 border-t border-border">
            <p className="text-xs text-muted-foreground flex items-center justify-center gap-2">
              <Mail className="w-4 h-4" />
              Vérifiez aussi vos spams si vous ne recevez pas l'email
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Success;
